// TOPからは?work=IDで受け、初期アンカージャンプを起こさず表示後に移動する。
export function initWorksNavigation(root, lenis) {
  const document = root.ownerDocument;
  const view = document.defaultView;
  const sections = new Map([...root.querySelectorAll('[data-work-section]')].map((section) => [section.id, section]));
  const initial = sections.get(new URL(view.location.href).searchParams.get('work'));
  const cleanups = [];
  let pending = Boolean(initial);
  let active = false;
  let destroyed = false;
  let timer = 0;
  let frame = 0;
  let sequence = 0;
  const listen = (target, type, callback, options) => {
    target.addEventListener(type, callback, options);
    cleanups.push(() => target.removeEventListener(type, callback, options));
  };
  const clear = () => {
    view.clearTimeout(timer);
    view.cancelAnimationFrame(frame);
    timer = frame = 0;
    pending = false;
    sequence++;
  };
  const cancel = () => {
    clear();
    if (active) lenis.scrollTo(lenis.actualScroll, { immediate: true, force: true });
    active = false;
  };
  const go = (target, replace = false) => {
    if (destroyed) return;
    clear();
    const run = sequence;
    active = true;
    const url = new URL(view.location.href);
    url.searchParams.delete('work');
    url.hash = target.id;
    view.history[replace ? 'replaceState' : 'pushState'](null, '', `${url.pathname}${url.search}${url.hash}`);
    lenis.resize();
    lenis.scrollTo(target, {
      duration: 1.1, lerp: 0,
      onComplete: () => {
        if (destroyed || sequence !== run) return;
        active = false;
        target.querySelector('h2').focus({ preventScroll: true });
      },
    });
  };
  const start = () => {
    if (!pending || destroyed) return;
    view.scrollTo(0, 0);
    frame = view.requestAnimationFrame(() => {
      frame = 0;
      // 新しいページが一度見えてから、案件の位置へスクロールする。
      timer = view.setTimeout(() => { if (pending) go(initial, true); }, 180);
    });
  };
  for (const link of root.querySelectorAll('[data-work-link]')) {
    listen(link, 'click', (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = sections.get(link.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      go(target);
    });
  }
  for (const type of ['wheel', 'touchstart', 'pointerdown']) listen(view, type, cancel, { passive: true });
  listen(view, 'keydown', (event) => {
    if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key)) cancel();
  });
  listen(view, 'pagehide', cancel);
  listen(document, 'visibilitychange', () => { if (document.hidden) cancel(); });
  if (document.readyState === 'complete') start();
  else listen(view, 'load', start, { once: true });
  return () => {
    destroyed = true;
    cleanups.forEach((cleanup) => cleanup());
    cancel();
  };
}
